import api from "./Api";

class PedidoItemDetToleranciaService {
  GetPedidoItemDetTolerancia(payload) {
    return api
      .get("/v1/pedidoItemDetTolerancia/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  PostPedidoItemDetTolerancia(payload) {
    return api
      .post("/v1/pedidoItemDetTolerancia/", payload)
      .then((response) => {
        return response.data;
      });
  }

  PutPedidoItemDetTolerancia(payload) {
    return api.put("/v1/pedidoItemDetTolerancia/", payload).then((response) => {
      return response.data;
    });
  }

  DeletePedidoItemDetTolerancia(payload) {
    return api
      .delete("/v1/pedidoItemDetTolerancia/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetPedidoItemDetToleranciaOData(payload) {
    return api
      .get("/OData/PedidoItemDetTolerancia" + payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new PedidoItemDetToleranciaService();
